$(document).ready(function(){
  
  // Card height function
  function refreshCardHeight(){
    // Reset height to 0
    var maxHeight = 0;
    $(".card__heading.h5").css('height', '');
    
    // Get the highest card height
    $(".card__heading.h5").each(function(){
      if ($(this).height() > maxHeight) { 
        maxHeight = $(this).height(); 
      }
    });
    
    // Set new highest height
     $(".card__heading.h5").height(maxHeight);
  }

  //run on page ready
  refreshCardHeight();

  // Trigger when window is resized
  $( window ).resize(function() {
    refreshCardHeight();
  });

}); 